import { createSlice } from "@reduxjs/toolkit";

const ecommerceOrderSlice = createSlice({
  name: "ecommerceOrder",
  initialState: {
    data: [],

    totalRows: 0,
    currentPage: 0,
    rowsPerPage: 5,

    newOrder : 0,

    searchTerm: "",
    filters: {
      status: "",
      payment: "",
      startDate: null,
      endDate: null,
      region_id : '',
      township_id: '',
      village_tract_id: '',
      village_id: '',
      settlement_id: '',
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
    action : {
      isLoading: false,
      isError: false,
      errorMessage:""
    }
  },
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
    },
    setTotalRows: (state, action) => {
      state.totalRows = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    // setCategoryIdFilter: (state, action) => {
    //   state.filters.category_id = action.payload;
    // },
    setStartDate: (state, action) => {
      state.filters.startDate = action.payload;
    },
    setEndDate : (state, action) => {
      state.filters.endDate = action.payload;
    },

    setRegionCodeFilter : (state, action) => {
      state.filters.region_id = action.payload;
    },

    setTownshipCodeFilter: (state, action) => {
        state.filters.township_id = action.payload;
    },
    setVillageTractCodeFilter: (state, action) => {
        state.filters.village_tract_id = action.payload;
    },
    setVillageCodeFilter: (state, action) => {
        state.filters.village_id = action.payload;
    },
    setSettlementFilter: (state, action) => {
      state.filters.settlement_id = action.payload;
    },
    
    setNewOrderCount : (state, action) => {
      state.newOrder = action.payload;
    },

    // fetch
    fetchingData : (state) => {
      state.isLoading = true;
      state.isError = false;
    },
    fetchDataSuccess : (state, action) => {
      action.payload.data && (state.data = action.payload.data);
      action.payload.total_items && (state.totalRows = action.payload.total_items);

      state.isLoading = false;
      state.isError = false;
    },
    fetchDataFail : (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.payload;
    },

    submittingData: (state) => {
      state.action.isLoading = true;
      state.action.isError = false;
      state.action.errorMessage = '';
    },
   
    submitDataSuccess : (state) => {
      state.action.isLoading = false;
      state.action.isError = false;
    },
    
    submitDataFail : (state,action) => {
      state.action.isLoading = false;
      state.action.isError = true;
      state.action.errorMessage = action.payload;
    },

    submittingCancel : (state) => {
      state.action.isLoading = false;
      state.action.isError = false;
      state.action.errorMessage = '';
    },

    setStatusFilter: (state, action) => {
      state.filters.status = action.payload;
    },

    setPaymentFilter: (state, action) => {
      state.filters.payment = action.payload;
    },

    reloadDialogState: (state) => {
      state.action = { isLoading: false, isError: false, errorMessage: ''}
    }
  },
});

export const {
  setData,
  setTotalRows,
  setCurrentPage,
  setRowsPerPage,
  setSearchTerm,
  setStartDate,
  setEndDate,
  setRegionCodeFilter,
  setTownshipCodeFilter,
  setVillageTractCodeFilter,
  setVillageCodeFilter,
  setSettlementFilter,
  setStatusFilter,
  setPaymentFilter,
  setNewOrderCount,
  submittingData,
  reloadDialogState,
  
  // fetch api
  fetchingData,
  fetchDataSuccess,
  fetchDataFail,
  submitDataSuccess,
  submitDataFail,
  submittingCancel
} = ecommerceOrderSlice.actions;

export default ecommerceOrderSlice.reducer;
